// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__qc0Mj","details":"styles_details__waTxm","name":"styles_name__zNR6s","publishedAt":"styles_publishedAt__OChVW"};